// import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import TrainerPhoto from './TrainerPhoto'
// import GymService from 'service/GymService'
import { IFilteredGymTrainerList } from 'types/GymType'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'
import {
  GymSalonName,
  ReservationButton,
  WorkingHours,
  SalonLocation,
  StyledCard,
  CardHeaderOverlay,
  TrainerSummary,
  // FavoriteContainer,
} from '../styled'

interface ComponentProps {
  trainer: IFilteredGymTrainerList
  openModal: (data: IFilteredGymTrainerList) => void
}

export default function GymTrainerCard({ trainer, openModal }: ComponentProps) {
  const { t } = useTranslation()
  const {
    // Id,
    priceStr,
    price,
    gymTrainerService,
    // IsFavorite,
    gymTrainer: { name, surname, employeeId },
    gymSaloon: {
      floor: { locationName: locName, districtName, cityName, countryName, blockName, name: floorName },
    },
  } = trainer || {}

  /* Variables - functions */
  const locationName = `${locName}, ${districtName}, ${cityName}, ${countryName}, ${blockName}, ${floorName}`
  const trainerServices = gymTrainerService?.map((ts) => ts.gymTrainerServiceType.name)
  const priceVal = !!price ? priceStr : t('most-used-words.price-free')

  const openReservationModal = () => openModal(trainer)

  // /* Favorite Gym Trainer */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   GymService.addGymTrainerFavorite(Id).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   GymService.removeGymTrainerFavorite(Id).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay hasPhoto>
        {/* <FavoriteContainer>
          <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} />
        </FavoriteContainer> */}

        <TrainerPhoto trainerEmployeeId={employeeId} />
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <GymSalonName>{`${name} ${surname}`}</GymSalonName>

          <SalonLocation>{locationName}</SalonLocation>
          {!!gymTrainerService.length && (
            <TrainerSummary>
              {trainerServices.map((ts, i) => (
                <span key={i}> {ts} </span>
              ))}
            </TrainerSummary>
          )}
        </div>

        <WorkingHours>
          <span className="wh-title">{t('most-used-words.hourly-price')}: </span>
          <span>{priceVal}</span>
        </WorkingHours>

        <ReservationButton onClick={openReservationModal}>{t('buttons.book-reservation')}</ReservationButton>
      </div>
    </StyledCard>
  )
}
